import { render, staticRenderFns } from "./bulletin.vue?vue&type=template&id=a3839e8c&scoped=true"
import script from "./bulletin.vue?vue&type=script&lang=js"
export * from "./bulletin.vue?vue&type=script&lang=js"
import style0 from "./bulletin.vue?vue&type=style&index=0&id=a3839e8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3839e8c",
  null
  
)

export default component.exports